import { updateDefaultSlug } from './path.defaults.js';
import { updateDefaultSeoDescription, updateDefaultSeoTitle } from './seo.defaults.js';
import { updateDefaultDisplayDate } from './date.defaults.js';
import { updateVgWortPixel } from './vgWort.defaults.js';
import { preserveAdsSegmentsFromPrevious } from './ads.defaults.js';
/**
 * Update default values of fields with autofill logic
 * Also used for scheduled updates - therefore DefaultsRelevantContent
 * @param content current document requested to be persisted
 * @param previousContent previous version of document currently stored in database
 */
export const updateDefaultValues = (content, previousContent) => {
    updateDefaultSeoTitle(content, previousContent);
    updateDefaultSeoDescription(content, previousContent);
};
/**
 * Update default values of fields with autofill logic
 * Only used on the full content
 * @param content current document requested to be persisted
 * @param previousContent previous version of document currently stored in database
 */
export const updateContentDefaultValues = (content, previousContent) => {
    updateDefaultDisplayDate(content);
    updateDefaultSlug(content, previousContent);
    updateVgWortPixel(content, previousContent);
    preserveAdsSegmentsFromPrevious(content, previousContent);
};
export * from './path.defaults.js';
export * from './seo.defaults.js';
export * from './vgWort.defaults.js';
export * from './affiliate.defaults.js';
//# sourceMappingURL=index.js.map